import { mxCell } from 'mxgraph-js';
import HCLMxGraphModel from './HCLMxGraphModel';
import FaultTreeVertex from '../HCLTreeNode/FaultTreeNode/FaultTreeVertex';

class FaultTreeMxGraphModel extends HCLMxGraphModel {
  public static getChildCount(root: FaultTreeVertex): number {
    const children: { [index: string]: FaultTreeVertex } = {};
    (root.edges || []).forEach((edge) => {
      if (edge.target && edge.source) {
        if (edge.target.getId() !== root.getId() && edge.source.getId() === root.getId()) {
          children[edge.source.getId()] = edge.source as FaultTreeVertex;
        }
      }
    });
    const childCount = Object.values(children).length;
    // Object.values(children).forEach((child: FaultTreeVertex) => {
    //   childCount += FaultTreeMxGraphEncoder.getChildCount(child);
    // });
    return childCount;
  }

  public getTopNodes(sorted = false): FaultTreeVertex[] {
    const edges: mxCell[] = [];
    const vertices: { [index: string]: FaultTreeVertex } = {};
    const cells = this.cells as mxCell[];
    Object.values(cells).forEach((cell) => {
      if (cell.edge) {
        edges.push(cell);
      } else if (cell.vertex) {
        vertices[cell.getId()] = cell as FaultTreeVertex;
      }
    });

    edges.forEach((edge) => {
      if (edge.target) {
        delete vertices[edge.target.getId()];
      }
    });

    const values = Object.values(vertices);
    if (sorted) {
      return values.sort((a, b) => (FaultTreeMxGraphModel.getChildCount(b) - FaultTreeMxGraphModel.getChildCount(a)));
    }
    return values;
  }
}

export default FaultTreeMxGraphModel;
